import { type MaybeRefOrGetter, toValue } from 'vue';
import type { ExcursionParams } from './useExcursionExperienceAggregations.ts';

const normalizeString = (value?: MaybeRefOrGetter<string | null>) => {
  const normalizedValue = value !== undefined ? toValue(value) : undefined;

  return normalizedValue || undefined;
};

const normalizeNullable = <T>(value?: MaybeRefOrGetter<T | null | undefined>) => {
  const normalizedValue = value !== undefined ? toValue(value) : undefined;

  return normalizedValue ?? undefined;
};

export const normalizeExcursionAggregations = (params: ExcursionParams) => {
  const tagSlugs = normalizeString(params.tag__slugs);

  return {
    city__slug: normalizeString(params.city__slug),
    type: normalizeString(params.type),
    start_date: normalizeString(params.start_date),
    end_date: normalizeString(params.end_date),
    movement_type: normalizeString(params.movement_type),
    start_price: normalizeNullable(params.start_price),
    end_price: normalizeNullable(params.end_price),
    start_duration: normalizeNullable(params.start_duration),
    end_duration: normalizeNullable(params.end_duration),
    persons_count: normalizeNullable(params.persons_count),
    page: normalizeNullable(params.page),
    tag__slugs: tagSlugs === 'all' ? undefined : tagSlugs,
    sorting: normalizeString(params.sorting),
    date_filter_mode: normalizeString(params.date_filter_mode),
    bookable: normalizeNullable(params.bookable),
    start_time_interval: normalizeString(params.start_time_interval),
    duration_interval: normalizeString(params.duration_interval),
    price_format: normalizeString(params.price_format),
    children_allowed: normalizeNullable(params.children_allowed),
    extended_movement_types: true,
  };
};
